import { render } from "./IconPhoneNumber.vue?vue&type=template&id=35d25fec"
import script from "./IconPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./IconPhoneNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script